export default __webpack_public_path__ + "static/media/Scope-5.fd117263.png";